// ============================================
// 기존 aiTransaction 재사용 (AIManagerRefact에서 복사)
// ============================================

// parseResponse 예외: 백엔드 응답을 가공해야 하는 인텐션 //
export const PARSE_RESPONSE_OVERRIDES = {
  'CHECK_MEMBER_SEARCH': (data) => {
    if (Array.isArray(data)) {
      return data.map(({ memberId, userId, name, birthDay, phone, profile }) => ({
        memberId, userId, name, birthDay, phone, profile,
      }));
    }
    return data;
  },
  'CHECK_MEMBER+EXPIRING_LIST_BY+PERIOD': (data) => {
    if (!data?.members) return data;
    return data.members.flatMap(member =>
      (member.expiringMemberships || []).map(m => ({
        memberId: member.memberId,
        memberName: member.memberName,
        phone: member.phone,
        profile: member.profile,
        memberShipName: m.memberShipName,
        startDate: m.startDate,
        endDate: m.endDate,
        remainingDays: m.remainingDays,
      }))
    );
  },
  // id=14: memberShipDetails만 사용 (memberShipHistoryDates 제외)
  'CHECK_MEMBER+MEMBERSHIP_DETAIL': (data) => {
    if (data?.memberShipDetails) return data.memberShipDetails;
    return data;
  },
  // id=16: selectedPaymentOptions flatMap
  'CHECK_MEMBER+PRODUCT_DETAIL': (data) => {
    if (!Array.isArray(data)) return data;
    return data.flatMap(item =>
      (item.selectedPaymentOptions || []).map(opt => ({
        merchantUid: item.merchantUid,
        itemName: item.itemName,
        totalPrice: item.totalPrice,
        paymentOptionName: opt.paymentOptionName,
        paymentPrice: opt.paymentPrice,
      }))
    );
  },
  // id=19: holdingHistory → holdingList flatMap
  'CHECK_MEMBER+MEMBERSHIP+HOLDING_DETAIL': (data) => {
    if (!data?.holdingHistory) return data;
    return data.holdingHistory.flatMap(h =>
      (h.holdingList || []).map(hold => ({
        memberId: data.memberId,
        memberName: data.memberName,
        usageId: h.usageId,
        memberShipName: h.memberShipName,
        holdingStartDate: hold.startDate,
        holdingEndDate: hold.endDate,
        holdingDays: hold.holdingDays,
        reason: hold.reason,
      }))
    );
  },
  // id=20: extendHistory → extendList flatMap
  'CHECK_MEMBER+MEMBERSHIP+EXTEND_DETAIL': (data) => {
    if (!data?.extendHistory) return data;
    return data.extendHistory.flatMap(h =>
      (h.extendList || []).map(ext => ({
        memberId: data.memberId,
        memberName: data.memberName,
        usageId: h.usageId,
        memberShipName: h.memberShipName,
        extendStartDate: ext.startDate,
        extendEndDate: ext.endDate,
        extendDays: ext.extendDays,
        reason: ext.reason,
      }))
    );
  },
  // id=25: members → canceledSubscriptions flatMap
  'CHECK_MEMBERSHIP+SUBSCRIPTION+CANCELLATION_LIST_BY+PERIOD': (data) => {
    if (!data?.members) return data;
    return data.members.flatMap(member =>
      (member.canceledSubscriptions || []).map(sub => ({
        memberId: member.memberId,
        memberName: member.memberName,
        phone: member.phone,
        profile: member.profile,
        memberShipName: sub.membershipName,
        cancelDate: sub.canceledDate,
        reason: sub.terminationReason,
      }))
    );
  },
  // id=26: categories → memberShips flatMap
  'CHECK_MEMBERSHIP+CATALOG_LIST': (data) => {
    if (!data?.categories) return data;
    return data.categories.flatMap(cat =>
      (cat.memberShips || []).map(ms => ({
        categoryName: cat.categoryName,
        memberShipId: ms.memberShipId,
        memberShipName: ms.memberShipName,
        totalPrice: ms.totalPrice,
        memberShipDuration: ms.memberShipDuration,
        totalCount: ms.totalCount,
      }))
    );
  },
  // id=33: lessons → reserves flatMap
  'CHECK_SCHEDULE+RESERVATION+STATUS_LIST_BY+PERIOD': (data) => {
    if (!data?.lessons) return data;
    return data.lessons.flatMap(lesson =>
      (lesson.reserves || []).map(r => ({
        scheduleId: lesson.scheduleId,
        lessonName: lesson.lessonName,
        classDate: lesson.classDate,
        classTime: lesson.classTime,
        memberId: r.memberId,
        memberName: r.name,
        phone: r.phone,
        reserveStatus: r.statusName,
      }))
    );
  },
  // id=34: lessons → reserves flatMap (상세 통계)
  'CHECK_SCHEDULE+RESERVATION+STATUS_DETAIL_BY+PERIOD': (data) => {
    if (!data?.lessons) return data;
    return data.lessons.flatMap(lesson =>
      (lesson.reserves || []).map(r => ({
        scheduleId: lesson.scheduleId,
        lessonName: lesson.lessonName,
        classDate: lesson.classDate,
        classTime: lesson.classTime,
        attendanceRate: lesson.attendanceRate,
        memberId: r.memberId,
        memberName: r.name,
        phone: r.phone,
        reserveStatus: r.statusName,
      }))
    );
  },
  // id=39: lessons → lesson 레벨 통계 (시간대는 classTime 요약만)
  'CHECK_RESERVE+ATTENDANCE_STATISTICS_BY+LESSON': (data) => {
    if (!data?.lessons) return data;
    return data.lessons.map(lesson => ({
      lessonName: lesson.lessonName,
      totalSessions: lesson.totalSessions,
      totalReservations: lesson.totalReservations,
      attendedCount: lesson.attendedCount,
      lateCount: lesson.lateCount,
      absentCount: lesson.absentCount,
      attendanceRate: lesson.attendanceRate,
      avgReservationsPerSession: lesson.avgReservationsPerSession,
      avgAttendedPerSession: lesson.avgAttendedPerSession,
      timeSlotCount: lesson.timeSlots?.length || 0,
      classTime: (lesson.timeSlots || []).map(s => s.classTime).join(', '),
    }));
  },
  // id=53: divisions → lockers flatMap
  'CHECK_LOCKER_LIST': (data) => {
    if (!data?.divisions) return data;
    return data.divisions.flatMap(div =>
      (div.lockers || []).map(locker => ({
        divisionName: div.divisionName,
        lockerId: locker.lockerId,
        lockerName: locker.lockerName,
        status: locker.status,
        memberName: locker.memberName,
        startDate: locker.startDate,
        endDate: locker.endDate,
      }))
    );
  },
  // id=52: histories → members flatMap
  'CHECK_BIZ_LIST_BY+PERIOD': (data) => {
    if (!data?.histories) return data;
    return data.histories.flatMap(h =>
      (h.members || []).map(m => ({
        sendType: h.sendType,
        title: h.title,
        content: h.content,
        createdDate: h.createdDate,
        successCount: h.successCount,
        failedCount: h.failedCount,
        memberName: m.memberName,
        phone: m.phone,
        sendStatus: m.sendStatus,
      }))
    );
  },
  // id=51: histories → members flatMap
  'CHECK_MESSAGE_LIST_BY+PERIOD': (data) => {
    if (!data?.histories) return data;
    return data.histories.flatMap(h =>
      (h.members || []).map(m => ({
        sendType: h.sendType,
        title: h.title,
        content: h.content,
        createdDate: h.createdDate,
        successCount: h.successCount,
        failedCount: h.failedCount,
        memberName: m.memberName,
        phone: m.phone,
        sendStatus: m.sendStatus,
      }))
    );
  },
  'CHECK_MEMBERSHIP+APPLICATION_LIST': (data) => data.waitMembers,
  'CHECK_SALES+YEAR_STATISTICS': (data) => ({ totalMaxPrice: data.totalMaxPrice, sales: data.sales }),
};

// "GET /api2/member/detail/{member_id}" → { method, apiVersion, path } //
export function parseEndpoint(endpointStr) {
  if (!endpointStr) return null;

  const spaceIdx = endpointStr.indexOf(' ');
  const method = endpointStr.slice(0, spaceIdx);
  const rawPath = endpointStr.slice(spaceIdx + 1);
  const versionMatch = rawPath.match(/^\/(api2?)\/(.*)/);

  if (!versionMatch) return null;

  return { method, apiVersion: versionMatch[1], path: versionMatch[2] };
}

// service + apiVersion + method → FetchModule 메서드명 //
export function resolveFetchMethod(service, apiVersion, method) {
  if (service === 'exercise') {
    return method === 'POST' ? 'postDataOfExerciseVersion2' : 'getDataOfExerciseVersion2';
  }

  if (apiVersion === 'api') {
    if (method === 'POST') return 'postData';
    return 'getIndividualData';
  }

  return method === 'POST' ? 'postDataVersion2' : 'getDataVersion2';
}

// endpoint path + params 스키마 → 최종 URL 생성 //
export function buildDynamicEndpoint(path, paramsSchema, paramValues) {
  const pathParamNames = [...path.matchAll(/\{(\w+)\}/g)].map(m => m[1]);

  let resolvedPath = path.replace(/\{(\w+)\}/g, (_, key) => {
    const camelKey = key.replace(/_(\w)/g, (__, c) => c.toUpperCase());
    return paramValues[camelKey] || paramValues[key] || '';
  });

  const queryKeys = (paramsSchema || [])
    .filter(p => !pathParamNames.includes(p.name) && !p.fixed)
    .map(p => p.name);
  if (queryKeys.length > 0) {
    const queryParams = new URLSearchParams();

    for (const key of queryKeys) {
      const camelKey = key.replace(/_(\w)/g, (_, c) => c.toUpperCase());
      const value = paramValues[camelKey] || paramValues[key];
      if (value) queryParams.append(key, value);
    }

    const query = queryParams.toString();
    if (query) resolvedPath = `${resolvedPath}?${query}`;
  }

  return resolvedPath;
}

// AI 로그 전송용 requestData 객체 생성 //
export function buildAiLogRequest({
  response, sessionId, conversationId, promptId,
  maxOutputTokens, elapsedMs, apiEndpoint, apiStatusCode }) {
  const usage = response?.usage || {};
  const inputTokens = usage.prompt_tokens || 0;
  const outputTokens = usage.completion_tokens || 0;

  return {
    respId: response?.id || null,
    sessionId: sessionId || '',
    conversationId: conversationId || null,
    promptId: promptId || 0,
    modelUsed: response?.model || 'unknown',
    maxOutputTokens: maxOutputTokens || null,
    inputTokens,
    outputTokens,
    reasoningTokens: usage.completion_tokens_details?.reasoning_tokens || 0,
    cachedTokens: usage.prompt_tokens_details?.cached_tokens || 0,
    totalTokens: usage.total_tokens || (inputTokens + outputTokens),
    createdAt: response?.created || null,
    completedAt: null,
    elapsedMs: elapsedMs || 0,
    error: response?.error || false,
    errorDetails: response?.errorDetails || null,
    rawResponse: JSON.stringify(response) ?? null,
    apiEndpoint: apiEndpoint || null,
    apiStatusCode: apiStatusCode || null,
  };
}
